import React from "react";

import { connect } from "react-redux";

import { setPasswordAction } from "../../_actions";
import "../Login/login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../images/OPPTIMISE_logo.png";

import swal from "sweetalert2";
import { history } from "../../_helpers";

class SetPassword extends React.Component {
  constructor(props) {
    super(props);



    this.state = {
      email: "",
      confirmPassword: "",
      password: "",
      submitted: false,
      passwordCheck: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    let setPassWordHashCode = this.props.location.pathname.split("/");

    let combineHashCode = `${setPassWordHashCode[setPassWordHashCode.length - 3]
      }/${setPassWordHashCode[setPassWordHashCode.length - 2]}`;

    let data = {
      hashCode: combineHashCode,
      data: {},
    };
    this.props.dispatch(setPasswordAction.setPasswordHandler(data, "get"));
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });

    let setPassWordHashCode = this.props.location.pathname.split("/");

    let combineHashCode = `${setPassWordHashCode[setPassWordHashCode.length - 3]
      }/${setPassWordHashCode[setPassWordHashCode.length - 2]}`;

    const data = {
      hashCode: combineHashCode,
      data: {
        password: this.state.password,
      },
    };



    if (this.state.password !== this.state.confirmPassword) {
      this.setState({ passwordCheck: true });

    } else {
      this.setState({ passwordCheck: false });

      this.props.dispatch(setPasswordAction.setPasswordHandler(data, "post"));
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.setPasswordReducerMain !== this.props.setPasswordReducerMain
    ) {
      if (
        !this.props.setPasswordReducerMain.setPasswordLoad !==
        this.props.setPasswordReducerMain.setPasswordError
      ) {
        if (this.props.setPasswordReducerMain.setPasswordData.status === true) {
          if (this.state.submitted) {
            swal({
              text: this.props.setPasswordReducerMain.setPasswordData.message,
              type: "success",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK",
            });
            setTimeout(() => {

              history.push("/login");
            }, 1000);
          }
        }
      }
    }
  }

  render() {

    const { setPasswordReducerMain } = this.props;
    const { password, confirmPassword, submitted, passwordCheck, email } =
      this.state;
    return (
      <div className="login-page text-white">
        <div className="logo text-center text-md-left py-3 px-md-5">
          <img src={logo} alt="OPPTiMiSE" />


        </div>

        <div className="container pt-5">
          <div className="d-flex flex-row justify-content-center">
            <div className="col-lg-5 col-md-8 col-11 px-0">
              <div className="login-field-page">
                {!setPasswordReducerMain.setPasswordLoad &&
                  !setPasswordReducerMain.setPasswordError && (
                    <p className="text-center py-3 py-lg-2 h4">Set Password</p>
                  )}

                {passwordCheck && (
                  <p className="text-center">
                    "Confirm Password" does not match Password
                  </p>
                )}
                <div className="">
                  {!setPasswordReducerMain.setPasswordLoad ? (
                    !setPasswordReducerMain.setPasswordError ? (
                      setPasswordReducerMain.setPasswordData.status ? (
                        <form method="post" onSubmit={this.handleSubmit}>

                          <div className="form-group">
                            <label
                              htmlFor="password"
                              className="text-uppercase"
                            >
                              <small>password</small>
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              id="password"
                              name="password"
                              required
                              value={password}
                              onChange={this.handleChange}
                            />
                            {submitted && !password && (
                              <div className="help-block">
                                password is required
                              </div>
                            )}
                          </div>
                          <div className="form-group">
                            <label
                              htmlFor="inputPassword4"
                              className="text-uppercase"
                            >
                              <small>Confirm Password</small>
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              id="inputPassword4"
                              name="confirmPassword"
                              required
                              value={confirmPassword}
                              onChange={this.handleChange}
                            />
                            {submitted && !confirmPassword && (
                              <div className="help-block">
                                Confirm Password is required
                              </div>
                            )}
                          </div>
                          <div className="form-group">
                            <div className="text-center">
                              <button
                                type="submit"
                                className="btn buttonColor btn-sm text-white px-3"
                              >
                                <small>SET PASSWORD</small>
                              </button>
                            </div>
                          </div>

                        </form>
                      ) : (
                        <LinkExpired />
                      )
                    ) : (
                      <LinkExpired />
                    )
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const LinkExpired = (props) => (
  <div>
    <h3 className="expiry-link-heading" style={{ textAlign: "center" }}>

      You have already created a password !
    </h3>
    <p style={{ display: "flex", justifyContent: "center" }}>
      Go to the login page to continue.
    </p>

    <div style={{ textAlign: "center" }}>
      <button
        className="btn btn-red btn-sm text-uppercase"
        onClick={() => {
          history.push("/login");
        }}
      >
        BACK TO LOGIN
      </button>
    </div>
  </div>
);

function mapStateToProps(state) {

  return state;
}

const connectedSetPassword = connect(mapStateToProps)(SetPassword);
export { connectedSetPassword as SetPassword };



// WEBPACK FOOTER //
// ./src/_pages/SetPassword/index.jsx